export const SET_ROOM = "SET_ROOM"
export const SET_TYPE_LIST = "SET_TYPE_LIST"
export const CLEAR_ROOM = "CLEAR_ROOM"
export const SET_IN_ROOM_FIELDS = "SET_IN_ROOM_FIELDS"
